import { InvoicingPdf } from '__generated__/GQL';
import { SupportedLanguages } from 'common/locale';

type DownloadPdf = {
  lang: SupportedLanguages;
  pdf: InvoicingPdf | null;
};

export const downloadPdf = ({ lang, pdf }: DownloadPdf) =>
  window.open(lang === 'fr' ? pdf?.frUrl : pdf?.enUrl, '_blank');
